export const PlaceholderEntity = Object.freeze({
    Email: 'Email',
    FullName: 'Full Name',
    PhoneNumber: 'Phone Number',

    Password: 'Password',
    CurrentPassword: 'Current Password',
    NewPassword: 'New Password',

    Percentage: '%',

    CsiCode: 'CSI Code',
    QtyUom: 'QTY (UOM)',

    WorkerRate: 'Worker Rate ($)',
    LaborProductivity: 'Labor Productivity (%)',
    WorkerHours: 'Worker Hours (Hr)',

    CostPerUnit: 'Cost Per Unit ($)',
    MaterialWaste: 'Material Waste (%)',

    CostPerHour: 'Cost Per Hour ($)',
    EquipmentProductivity: 'Equipment Productivity (%)',
    HoursSpent: 'Hours Spent (Hr)',

    ProjectName: 'Project Name',
    ConstructionType: 'Construction Type',
    Category: 'Category',

    TokenCount: 'Token Count',

    AllDivisions: 'All Divisions'
});

export type PlaceholderEntityType = (typeof PlaceholderEntity)[keyof typeof PlaceholderEntity];

export const PlaceholderAction = Object.freeze({
    Enter: 'Enter',
    Select: 'Select',
    Confirm: 'Confirm'
});

export type PlaceholderActionType = (typeof PlaceholderAction)[keyof typeof PlaceholderAction];

export const getPlaceholder = (action: PlaceholderActionType, entity: PlaceholderEntityType) => `${action} ${entity}`;
